package br.com.vvrefeicoes.portal

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import br.com.vvrefeicoes.portal.core.di.AppGraph
import br.com.vvrefeicoes.portal.core.di.LocalAppGraph
import br.com.vvrefeicoes.portal.core.ui.theme.AppTheme
import br.com.vvrefeicoes.portal.core.util.publicMonitorCodeFromUrl
import br.com.vvrefeicoes.portal.feature.monitor.PublicMonitorScreen
import br.com.vvrefeicoes.portal.feature.shell.AdminShell
import br.com.vvrefeicoes.portal.navigation.AuthNavHost
import kotlinx.coroutines.CancellationException

@Composable
@Preview
fun App() {
    val appGraph = remember { AppGraph() }
    CompositionLocalProvider(LocalAppGraph provides appGraph) {
        AppTheme {
            val publicMonitorCode = publicMonitorCodeFromUrl()
            if (publicMonitorCode != null) {
                PublicMonitorScreen(publicMonitorCode)
            } else {
                // Enquanto tenta recuperar a sessão salva, mostra um loader para o login não piscar no F5.
                var restoring by remember { mutableStateOf(true) }
                LaunchedEffect(Unit) {
                    try {
                        appGraph.authRepository.restoreSession()
                    } catch (exception: CancellationException) {
                        throw exception
                    } catch (throwable: Throwable) {
                        // Sem sessão restaurável: segue para o login.
                    }
                    restoring = false
                }

                val session by appGraph.authRepository.session.collectAsStateWithLifecycle()
                when {
                    restoring ->
                        Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                            CircularProgressIndicator()
                        }
                    session == null -> AuthNavHost()
                    else -> AdminShell()
                }
            }
        }
    }
}
